module.exports = __webpack_public_path__ + "img/min-circle.ff1318c4.png";